import Counters from "../../components/Home/Counters";
import Campus from "../../components/Home/Campus";
import Hero from "../../components/Home/Hero";
import Highlights from "../../components/Home/Highlights";
import Layout from "../../components/Layouts/Layout";
import SponsorList from "../../components/Sponsor/SponsorList";
import Activities from "../../components/Home/Activities";
import Title from "../../components/Title/Title";
import MediaPartners from "../../components/Home/MediaPartners";
import CommunityPartners from "../../components/Home/CommunityPartners";
import TechnicalCollaborators from "../../components/Home/TechnicalCollaborators";
import EntertainmentModal from "../../components/Home/EntertainmentModal";
import Timeline from "../../components/Home/Timeline";
import Conference from "../../components/Home/Conference";

// Set this to true when the event timeline is ready to be shown again.
const SHOW_TIMELINE = false;
const SHOW_ENTERTAINMENT_MODAL =
  process.env.REACT_APP_SHOW_ENTERTAINMENT_MODAL === "true";

const Home = () => {
  return (
    <Layout title="Home" size="full">
      {SHOW_ENTERTAINMENT_MODAL && <EntertainmentModal />}
      <div className="homepage scroll-smooth">
        <Hero showTimeline={SHOW_TIMELINE} />
        {SHOW_TIMELINE && <Timeline />}

        <Highlights />

        <Conference />

        <Activities />
        <Title text="Our Sponsors" />
        <SponsorList cols={3} />
        <MediaPartners />
        <CommunityPartners />
        <TechnicalCollaborators />
        <Counters />
        <Campus />
      </div>
    </Layout>
  );
};

export default Home;
